import { jsx as l, Fragment as c, jsxs as p } from "react/jsx-runtime";
import { isFunction as f } from "@waitroom/utils";
import { Fragment as s } from "react";
const u = (n, t = ", ") => {
  if (!n || !n.length) return "";
  const o = n.length;
  return /* @__PURE__ */ l(c, { children: n.map((e, r) => /* @__PURE__ */ p(s, { children: [
    e,
    r < o - 1 ? t : ""
  ] }, r)) });
}, F = (n, t, o) => {
  if (!n || !n.length) return "";
  const e = f(t) ? (i, h) => /* @__PURE__ */ l(s, { children: t(i, h) }, h) : (i) => i[t] || "", r = [...n].filter(Boolean), m = r.length;
  if (m <= 1) return /* @__PURE__ */ l(c, { children: r.map(e) });
  const a = r.pop();
  return /* @__PURE__ */ p(c, { children: [
    u(r.map(e)),
    " ",
    o,
    " ",
    e(a, m - 1)
  ] });
}, j = (n, t = 2) => Array(t).fill(null).map((o, e) => /* @__PURE__ */ l(s, { children: n }, e));
export {
  u as joinJsx,
  F as joinWithAndJsx,
  j as repeat
};
